"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockObjectFromSchema = createMockObjectFromSchema;
function createMockObjectFromSchema(schema, path = '', depth = 0, safe = true) {
    const MAX_DEPTH = 10;
    if (depth >= MAX_DEPTH) {
        if (safe) {
            return {};
        }
        throw new Error(`Schema has surpassed the maximum allowed depth. Please specify a more shallow payload schema. Max depth: ${MAX_DEPTH}`);
    }
    if ((schema === null || schema === void 0 ? void 0 : schema.type) !== 'object' || !(schema === null || schema === void 0 ? void 0 : schema.properties)) {
        if (safe) {
            return {};
        }
        throw new Error('Schema must define an object with properties.');
    }
    return Object.entries(schema.properties).reduce((acc, [key, definition]) => {
        if (typeof definition === 'boolean') {
            return acc;
        }
        const currentPath = path && path.length > 0 ? `${path}.${key}` : key;
        if (definition.default) {
            acc[key] = definition.default;
        }
        else if (definition.type === 'object' && definition.properties) {
            acc[key] = createMockObjectFromSchema(definition, currentPath, depth + 1);
        }
        else {
            acc[key] = `{{${currentPath}}}`;
        }
        return acc;
    }, {});
}
